import { toCsv } from '@aithora/shared';

/**
 * Download the rows already on screen as a CSV (design exportCsv, L33343): every cell
 * quoted, UTF-8, the link revoked after two seconds. Only what the page has loaded is
 * written; nothing is fetched for the file.
 */
export function exportCsv(cols: readonly string[], rows: readonly (readonly unknown[])[], filename: string): void {
  const url = URL.createObjectURL(new Blob([toCsv(cols, rows)], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
